module.exports = __webpack_public_path__ + "media/images/pages/i-belong/i_belong_flag-95ae8246c6fc238d2324c2b3a7bb5eac.svg";